module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form', {
    ref: "Form",
    attrs: {
      "model": _vm.Form,
      "label-position": _vm.labelPosition,
      "rules": _vm.FormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "负责人姓名",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Name),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Name", $$v)
      },
      expression: "Form.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "Sex"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.Form.Sex),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Sex", $$v)
      },
      expression: "Form.Sex"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人手机",
      "prop": "Phone"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Phone),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Phone", $$v)
      },
      expression: "Form.Phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负责人邮箱",
      "prop": "Email"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.Form.Email),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Email", $$v)
      },
      expression: "Form.Email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.Form.Remark),
      callback: function($$v) {
        _vm.$set(_vm.Form, "Remark", $$v)
      },
      expression: "Form.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7cd24c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Competition/TeamLeader.vue
// module id = 1319
// module chunks = 1